module.exports = __webpack_public_path__ + "../resources/img/storebadge_fr.b038e6c6.png";